/** @file Scale tool registration: title and activation chord R (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Scales the selected bones (setup values or keys). */
export const tool: ToolDef = { id: 'scale', title: 'tools.scale.title', bindings: [{ id: 'tool.scale', keys: 'KeyR', context: 'viewport' }] };
